<app-homepage-header pageName="{{'home-page-content.contact' | translate}}"></app-homepage-header>

<form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
  <section class="section-wrapper contact-us-lg">
    <div class="background-image-wrapper">
      <img src="assets/contact-us/background.png" alt="bg">
    </div>
    <div class="container">
      <div class="contact-us-title-container">
        <span class="title">{{'contact_content.with_us' | translate}}</span>
        <span class="text">{{'contact_content.with_us_text' | translate}}</span>
      </div>

      <div class="contact-us-form-container mt-70px">
        <div class="address-info width-49">
          <div class="address flex-direction-column">
            <span class="address-info-title">{{'contact_content.address' | translate}}</span>
            <span class="address-info-text">
            {{'contact_content.country' | translate}}<br>
              {{'contact_content.street' | translate}}<br>
              {{'contact_content.scanme_LLC' | translate}}<br>
              {{'contact_content.tax_id' | translate}} 05559428
          </span>
          </div>
          <div class="contact-us-info">
            <div class="info-left">
              <span class="address-info-title">{{'contact_content.tel' | translate}}</span>
              <span class="address-info-text">{{ CONTACT_US_PHONE }}</span>
            </div>
            <div class="info-right">
              <span class="address-info-title">{{'contact_content.hours' | translate}}</span>
              <span class="address-info-text">10:00-18:00</span>
            </div>
          </div>
          <div class="social-media-container">
            <span class="address-info-title">{{'home-page-content.stay_connected' | translate}}</span>
            <app-social-media></app-social-media>
          </div>
        </div>

        <div class="contact-form-container width-49 ">
          <span class="contact-form-title">{{'contact_content.question' | translate}}</span>
          <div class="contact-form-body mt-3">
            <div class="flex-direction-column">
              <div class="flex-direction-row justify-content-between ">
                <mat-form-field class="width-49 mb-2">
                  <mat-label>{{'contact_content.full_name' | translate}}</mat-label>
                  <input matInput formControlName="fullName" (blur)="setValidators(SharedConstants.FULL_NAME)"/>
                  <mat-error *ngIf="contactForm.get('fullName')?.hasError('required')">
                    {{'contact_content.full_name_required_error' | translate}}
                  </mat-error>
                </mat-form-field>
                <mat-form-field class="width-49 mb-2">
                  <mat-label>{{'contact_content.email_address' | translate}}</mat-label>
                  <input matInput formControlName="email" (blur)="setValidators(SharedConstants.EMAIL)"/>
                  <mat-error *ngIf="contactForm.get('email')?.hasError('required')">
                    {{'contact_content.email_required_error' | translate}}
                  </mat-error>
                </mat-form-field>
              </div>
              <mat-form-field class="i-width-100 info-left">
                <mat-label>{{'contact_content.phone' | translate}}</mat-label>
                <input matInput formControlName="phone"/>
              </mat-form-field>
              <mat-form-field class="i-width-100 mb-2">
                <mat-label>{{'contact_content.help' | translate}}</mat-label>
                <textarea matInput formControlName="message" rows="5" maxlength="1000" (blur)="setValidators(SharedConstants.MESSAGE.toLowerCase())"></textarea>
                <mat-error *ngIf="contactForm.get('message')?.hasError('required') && contactForm.get('message')?.touched">
                  {{'contact_content.message_required_error' | translate }}
                </mat-error>
              </mat-form-field>
              <button type="submit" class="filled-button tall-button">{{'contact_content.submit' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section-wrapper-mb contact-us-mb">
    <div class="contact-us-title-container">
      <span class="title">{{'contact_content.with_us' | translate}}</span>
      <span class="text">{{'contact_content.with_us_text' | translate}}</span>
    </div>

    <div class="address-info i-width-100 mt-70px">
      <div class="address flex-direction-column">
        <span class="address-info-title">{{'contact_content.address' | translate}}</span>
        <span class="address-info-text">
            {{'contact_content.country' | translate}}<br>
          {{'contact_content.street' | translate}}<br>
          {{'contact_content.scanme_LLC' | translate}}<br>
          {{'contact_content.tax_id' | translate}} 05559428
          </span>
      </div>

      <div class="contact-us-info-mb">
        <span class="address-info-title">{{'contact_content.tel' | translate}}</span>
        <span class="address-info-text">{{ CONTACT_US_PHONE }}</span>
      </div>

      <div class="contact-us-info-mb">
        <span class="address-info-title">{{'contact_content.hours' | translate}}</span>
        <span class="address-info-text">10:00-18:00</span>
      </div>

      <div class="social-media-container">
        <span class="address-info-title">{{'home-page-content.stay_connected' | translate}}</span>
        <app-social-media></app-social-media>
      </div>
    </div>

    <div class="contact-form-container i-width-100 mt-30px">
      <span class="contact-form-title">{{ 'contact_content.question' | translate }}</span>
      <div class="contact-form-body mt-3">
        <div class="flex-direction-column">
          <mat-form-field class="i-width-100">
            <mat-label>{{ 'contact_content.full_name' | translate }}</mat-label>
            <input matInput formControlName="fullName" (blur)="setValidators(SharedConstants.FULL_NAME)"/>
            <mat-error *ngIf="contactForm.get('fullName')?.hasError('required')">
              {{ 'contact_content.full_name_required_error' | translate }}
            </mat-error>
          </mat-form-field>
          <mat-form-field class="i-width-100">
            <mat-label>{{ 'contact_content.email_address' | translate }}</mat-label>
            <input matInput formControlName="email" (blur)="setValidators(SharedConstants.EMAIL)"/>
            <mat-error *ngIf="contactForm.get('email')?.hasError('required')">
              {{ 'contact_content.email_required_error' | translate }}
            </mat-error>
          </mat-form-field>
          <mat-form-field class="i-width-100">
            <mat-label>{{ 'contact_content.phone' | translate }}</mat-label>
            <input matInput formControlName="phone"/>
          </mat-form-field>
          <mat-form-field class="i-width-100">
            <mat-label>{{ 'contact_content.help' | translate }}</mat-label>
            <textarea matInput formControlName="message" rows="5" maxlength="1000" (blur)="setValidators(SharedConstants.MESSAGE.toLowerCase())"></textarea>
            <mat-error *ngIf="contactForm.get('message')?.hasError('required') && contactForm.get('message')?.touched">
              {{ 'contact_content.message_required_error' | translate }}
            </mat-error>
          </mat-form-field>
          <button type="submit"
                  class="filled-button tall-button mobile-button">{{ 'contact_content.submit' | translate }}
          </button>
        </div>
      </div>
    </div>
  </section>
</form>

<div class="mt-100px">
  <app-footer></app-footer>
</div>
